import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GenModel } from '../../shared/models/genmodel';
import { environment } from '../../../environments/environment.prod';
import { BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GenModelService {
  baseUrl = environment.apiUrl;
  private digitalTags$ = new BehaviorSubject([]);
  private skills$ = new BehaviorSubject([]);
  digitalTags = this.digitalTags$.asObservable();
  skills = this.skills$.asObservable();
  private sub = new Subject<any>();
  chipSub = new Subject<any>();
  skillSub = new BehaviorSubject<any>([]);
  constructor(private http: HttpClient) {}

  // updateDigitalTags(data: KeyValuePair[]) {
  //   this.digitalTags$.next(data)
  // }
  setClearEvent() {
    this.sub.next('');
  }
  get clearEvent() {
    return this.sub.asObservable();
  }

  // updateskills(data: KeyValuePair[]) {
  //     this.skills$.next(data)
  //   }

  chip_removeParent(closebtn) {
    closebtn.target.parentNode.remove();
  }

  //for post top banner
  getReqAPIData(reqId) {
    return this.http.get<any>(this.baseUrl + 'getRequisitionForPosting/' + reqId);
  }

  getPostingGenModel(companyHiringTypeId: number) {
    return this.http.get<GenModel>(this.baseUrl + 'getGenModelStructure/Posting/' + companyHiringTypeId);
  }

  editGenModelStructure(obj: any) {
    return this.http.post<GenModel>(this.baseUrl + 'editGenModelStructure', obj);
    // return this.http.post<GenModel>('./assets/json/posting.json',obj);
  }

  getRequisitionGenModel(companyHiringTypeId: number) {
    // switch(type){
    //     case 'IL': return this.http.get<GenModel>('../../assets/json/requisition.json');
    //     case 'BPM': return this.http.get<GenModel>('../../assets/json/requisition-bpm.json');
    //     case 'Fresher': return this.http.get<GenModel>('../../assets/json/requisition-fresher.json');
    // }
    return this.http.get<GenModel>(this.baseUrl + 'getGenModelStructure/Requisition/' + companyHiringTypeId);
    //  return this.http.get<GenModel>('../../assets/json/requisition.json');
  }

  getSkillByRequisitonId(id) {
    return this.http.get<any>(this.baseUrl + 'getSkillMasterDetailsByRequisitonId/' + id);
    // return this.http.get<TabularModel>('./assets/json/educationTable.json');
  }
  resetChip() {
    this.chipSub.next('');
  }

  get resetChipEvent() {
    return this.chipSub.asObservable();
  }

  setSkillData(data) {
    this.skillSub.next(data);
  }

  getskillData() {
    return this.skillSub.asObservable();
  }
}
